import qs from 'qs'
import axios from 'axios'
import { client, isWeiXin } from "../../utils/utils"
import translateLang from './lang'
import PrinterDownloads from './components/PrinterDownloads.vue'
import { getMacArchitecture, printerDownloads } from './printer'

export default  {
  components: { PrinterDownloads },
  data(){
    return {
      printerChoicesVisible: false,
      printerDetecting: false,
      adminShow: false,
      saleShow: false,
      warehouseShow:false,
      showTips: false,
      ios: {
        admin: "https://itunes.apple.com/cn/app/id1425786386?mt=8",
        sale: "https://itunes.apple.com/cn/app/id1435128540?mt=8",
        warehouse:"https://apps.apple.com/us/app/mc-warehouse/id6736793448"
      },
      android: {
        admin: "",
        sale: "",
        warehouse:""
      },
      googlePlay: {
        admin:
          "https://play.google.com/store/apps/details?id=com.efolix.mc.admin",
        sale:
          "https://play.google.com/store/apps/details?id=com.efolix.mc.selller"
      },
      languageList:[
        // 语言列表
        {key:'chs',title:'简体中文'},
        {key:'en',title:'English'},
        {key:'fr',title:'Français'},
        {key:'it',title:'Italiano'},
        {key:'es',title:'España'},
        {key:'de',title:'Deutsch'},
        {key:'pt',title:'Português'},
        {key:'tr',title:'Türkçe'},
        {key:'pl',title:'Polskie'}
      ],
      selectLang:'en', // 选中的语言
      getLanguages:{}, // 接口返回的语言

      iosAdminV:'', // ios黑端的版本号
      iosSaleV:'', // ios蓝端的版本号
      androidAdminV:'', // android黑端的版本号
      androidSaleV:'', // android蓝端的版本号
      iosWarehouseV:"", // ios黄端的版本号
      androidWarehouseV:"" // android黄端的版本号
    }
  },
  computed:{
    client() {
      // 设备类型
      return client()
    },
    downloadClient(){
      const obj = {
        IOS:"IOS",
        IPAD:"IOS",
        MACOSX:"IOS",
        Android:"Android",
        PC:"Android"
      }
      const clientInfo = this.client
      return obj[clientInfo]
    },
    showPrinter() {
      return this.client === 'MACOSX' || this.client === 'PC' || this.client === 'IPAD'
    },
    lang(){
      // 浏览器设置的语言
      const langs = ['zh_cn', 'zh', 'en', 'fr', 'de', 'es', 'it', 'pt', 'tr']
      const localLang = (navigator.language || navigator.userLanguage).toLowerCase().replace('-', '_')
      let lang = 'en'
      langs.forEach((l) => {
        if (localLang.includes(l)) {
          lang = l
        }
      })
      if(lang === 'zh'){
        lang = 'chs'
      }
      return lang
    },
    firstTip(){
      // 第一条提示
      return this.getLanguages['click_menu_button']
    },
    secondTip(){
      // 第二条提示
      return this.getLanguages['select_sys_browser']
    },
    adminV(){
      // 黑端版本
      return this.downloadClient === "IOS" ? this.iosAdminV : this.androidAdminV
    },
    saleV(){
      // 蓝端版本
      return this.downloadClient === "IOS" ? this.iosSaleV : this.androidSaleV
    },
    warehouseV(){
      // 黄端版本
      return this.downloadClient === "IOS" ? this.iosWarehouseV: this.androidWarehouseV
    }
  },
  methods:{
    getUrlParams() {
      const params = qs.parse(window.location.search.slice(1))
      if (params.android || params.v) {
        const verArr = this.getVObj(params.android || params.v)
        this.androidAdminV = verArr.adminV || ''
        this.androidSaleV = verArr.saleV || ''
        this.androidWarehouseV = verArr.warehouseV || ''
      }
      if(params.ios){
        const verArr = this.getVObj(params.ios)
        this.iosAdminV = verArr.adminV || ''
        this.iosSaleV = verArr.saleV || ''
        this.iosWarehouseV = verArr.warehouseV || ''
      }
    },
    getVObj(v){
      const ver = v
      const verArr = ver.split("_")
      return {
        adminV:verArr[0],
        saleV:verArr[1],
        warehouseV:verArr[2] // 这是个新加的用于指定仓管端版本的参数，版本参数用_来连接，第一个表示管理端，第二个表示销售端，第三个表示仓管端
      }
    },
    getMCUrl(pid, ver) {
      return ver
        ? axios.get(
            `https://api2.dokkr.net/index.php/user/get_app_info?app_pid=${pid}&version=${ver}`
          )
        : axios.get(
            `https://api2.dokkr.net/index.php/user/get_app_info?app_pid=${pid}`
          )
    },downloadZ() {
      window.location.href = 'https://link.microstore.app/install/merchant'
    },
    downloadL() {
      window.location.href = 'https://link.microstore.app/install/purchaser'
    },
    async downloadP() {
      if (this.client !== 'MACOSX' && this.client !== 'IPAD') {
        window.location.href = printerDownloads.windows
        return
      }
      if (this.printerDetecting) return
      this.printerDetecting = true
      try {
        // iPad users must choose the target Mac's chip, not the iPad's architecture.
        const architecture = this.client === 'MACOSX' ? await getMacArchitecture() : null
        this.printerChoicesVisible = !architecture
        if (architecture) {
          // Same-tab navigation avoids popup blocking after asynchronous detection.
          window.location.href = printerDownloads[architecture]
        }
      } finally {
        this.printerDetecting = false
      }
    },
    handleGooglePlay(app) {
      window.location.href = this.googlePlay[app]
      window.parent.postMessage({ url: this.googlePlay[app] }, "*")
    },
    handleDownload(app) {
      window.location.href = this.android[app]
      window.parent.postMessage({ url: this.android[app] }, "*")
    },
    async handleChange(){
      // 选择器进行选择
        await this.getLanguageList(this.selectLang)
    },
    async getLanguageList(lang){
      const keys = ['click_menu_button','select_sys_browser']
      // 更新语言
      window.showLoading()
      const res = await translateLang(lang,keys)
      window.hideLoading()

      if(Number(res.data.err) === 0){
        this.getLanguages = res.data.info || {} // 获取多语言词条
      }
    }
  }
}
